import { createSlice } from '@reduxjs/toolkit';
import { service } from '../shared/_services/api_service';
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  examinationData: [],
  totalExamination: 0,
  isOpenModal: false,
  isStatusOpenModal: false,
};

export const examinationSlice = createSlice({
  name: "examination",
  initialState,
  reducers: {
    setExaminationData(state, { payload }) {
      state.examinationData = payload.result;
      state.totalExamination = payload.total;
    },
    updateExaminationData(state, { payload }) {
      const objIndex = state.examinationData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.examinationData[objIndex] = payload;
      }
    },
    deleteExaminationData(state, { payload }) {
      const objIndex = state.examinationData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.examinationData.splice(objIndex, 1);
      }
    },
    pushExaminationData(state, { payload }) {
      state.examinationData.unshift(payload);
    },
    isOpenModal(state, { payload }) {
      state.isOpenModal = payload;
    },
    ModalToggle(state) {
      state.isOpenModal = !state.isOpenModal;
    },
    isOpenStatusModal(state, { payload }) {
      state.isStatusOpenModal = payload;
    },
    statusToggle(state) {
      state.isStatusOpenModal = !state.isStatusOpenModal;
    },
  }
});

export const {
  setExaminationData,
  updateExaminationData,
  deleteExaminationData,
  pushExaminationData,
  isOpenModal,
  ModalToggle,
  isOpenStatusModal,
  statusToggle,
} = examinationSlice.actions;

export default examinationSlice.reducer;

export function getExamination(limit = 10, offset = 0, status = '', keyword = '', testSeriesId = '') {
  return async function getExaminationThunk(dispatch) {
    dispatch(setLoading(true));
    try {
      const response = await service.getExamination(limit, offset, status, keyword, testSeriesId);
      dispatch(setExaminationData({ result: response.data.result, total: response.data.count }));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      if (error && error.response) {
        errorHandler(error.response);
      }
    }
  };
}

export function addExamination(payload) {
  return async function addExaminationThunk(dispatch) {
    dispatch(setLoading(true));
    try {
      const response = await service.addExamination(payload);
      dispatch(pushExaminationData(response.data));
      dispatch(setLoading(false));
      dispatch(isOpenModal(false));
      successHandler('Added Examination Successfully');
    } catch (error) {
      dispatch(setLoading(false));
      if (error && error.response) {
        errorHandler(error.response);
      }
    }
  };
}

export function updateExamination(id, payload) {
  return async function updateExaminationThunk(dispatch) {
    dispatch(setLoading(true));
    try {
      const response = await service.updateExamination(id, payload);
      dispatch(updateExaminationData(response.data));
      dispatch(setLoading(false));
      dispatch(isOpenModal(false));
      successHandler('Updated Examination Successfully');
    } catch (error) {
      dispatch(setLoading(false));
      if (error && error.response) {
        errorHandler(error.response);
      }
    }
  };
}

export function statusUpdateExamination(id, status) {
  return async function statusUpdateExaminationThunk(dispatch) {
    dispatch(setLoading(true));
    try {
      const response = await service.statusUpdateExamination(id, status);
      dispatch(updateExaminationData(response.data));
      dispatch(setLoading(false));
      dispatch(isOpenStatusModal(false));
      successHandler('Status Updated Successfully');
    } catch (error) {
      dispatch(setLoading(false));
      if (error && error.response) {
        errorHandler(error.response);
      }
    }
  };
}

export function deleteExamination(id) {
  return async function deleteExaminationThunk(dispatch) {
    dispatch(setLoading(true));
    try {
      await service.deleteExamination(id);
      dispatch(deleteExaminationData(id));
      dispatch(setLoading(false));
      successHandler('Deleted Examination Successfully');
    } catch (error) {
      dispatch(setLoading(false));
      if (error && error.response) {
        errorHandler(error.response);
      }
    }
  };
}

export function updateExaminationImage(id, file) {
  return async function updateExaminationImageThunk(dispatch) {
    dispatch(setLoading(true));
    try {
      const response = await service.updateExaminationImage(id, file);
      dispatch(updateExaminationData(response.data));
      dispatch(setLoading(false));
      successHandler('Image Icon Uploaded Successfully');
    } catch (error) {
      dispatch(setLoading(false));
      if (error && error.response) {
        errorHandler(error.response);
      }
    }
  };
}
